import { connectAPI } from "./api"
import { ReceiveJSON, ReceiveNothing } from "./api/base"
import { Receiver } from "./models/api/api"
import {
    IContract,
    IGlobalSettings,
    IReportData,
} from "../components/contracts"

const baseUrl = "contracts"

const ReceiveErrorMessage: Receiver = {
    accept: "application/json",
    handler: (response: Response) => {
        if (!response.ok) {
            throw response
        }
    },
}

export const collectContracts = (validate: boolean): Promise<IContract[]> =>
    connectAPI.getJSON(`${baseUrl}?validate=${validate}`)

export const enableContract = (id: string, enabled: boolean): Promise<void> =>
    connectAPI.postJSON(`${baseUrl}/${id}/enable`, enabled, ReceiveErrorMessage)

export const getContractDetails = (id: string): Promise<IContract> =>
    connectAPI.getJSON(`${baseUrl}/${id}?withcontent=true`)

export const validateContract = (id: string): Promise<IReportData> =>
    connectAPI.getJSON(`${baseUrl}/${id}/validate`)

export const repairContract = (id: string): Promise<IReportData> =>
    connectAPI.postVoid(`${baseUrl}/${id}/repair`, ReceiveJSON)

export const getContractsConfiguration = (): Promise<IGlobalSettings> =>
    connectAPI.getJSON(`${baseUrl}/configuration`)

export const setContractsConfiguration = (
    settings: IGlobalSettings,
): Promise<void> =>
    connectAPI.postJSON(`${baseUrl}/configuration`, settings, ReceiveNothing)
